import {
    createContext,
    useContext,
    useState,
    useCallback
} from "react";

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
    const [notification, setNotification] = useState({
        isOpen: false,
        message: "",
        type: "success"
    });

    const triggerNotification = useCallback((message, type = "success") => {
        setNotification({
            isOpen: true,
            message,
            type
        });
    }, []);

    const handleCloseNotification = useCallback(() => {
        setNotification(prev => ({
            ...prev,
            isOpen: false
        }));
    }, []);

    return (
        <NotificationContext.Provider value={{
            notification,
            triggerNotification,
            handleCloseNotification
        }}>
            {children}
        </NotificationContext.Provider>
    );
};

export const useNotification = () => {
    const context = useContext(NotificationContext);

    if (!context) {
        throw new Error("useNotification must be used within NotificationProvider");
    }

    return context;
};